import React from 'react';
import ReactDOM from 'react-dom';
import App from './Core/App';
ReactDOM.render(React.createElement(App, null), document.getElementById('react-root'));
